import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bde5e44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal_wrapper" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "modal-title" }, " Invite a team-mate to your Iknowa platform "),
  /*#__PURE__*/_createElementVNode("p", null, "Add a personalised message.")
], -1))
const _hoisted_4 = { class: "input__form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email Addresses:", -1))
const _hoisted_6 = { class: "input__form" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "select Permission: ", -1))
const _hoisted_8 = { class: "input__form" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Message (Optional): ", -1))
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = { class: "bottom-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    width: "570px",
    "max-width": "100%",
    modelValue: $setup.isShowModel,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.isShowModel) = $event)),
    class: "invite__modal__box",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("main", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createVNode(_component_v_btn, {
              class: "close-icon",
              variant: "text"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-close",
                  onClick: $props.onCloseForm
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_form, {
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
              rules: $setup.validation,
              ref: "memberFormRef"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_v_text_field, {
                    density: "compact",
                    rules: $setup.validation.email,
                    placeholder: "enter email address",
                    modelValue: $setup.memberForm.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.memberForm.email) = $event)),
                    variant: "outlined",
                    class: "c-input-border rounded-8px"
                  }, null, 8, ["rules", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_v_select, {
                    items: $setup.permissionType,
                    modelValue: $setup.memberForm.permissionType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.memberForm.permissionType) = $event)),
                    rules: $setup.validation.permissionType,
                    "item-title": "type",
                    "item-value": "id",
                    placeholder: "Select Permission",
                    variant: "outlined"
                  }, null, 8, ["items", "modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_v_textarea, {
                    class: "c-input-border rounded-8px textarea__wrapper",
                    modelValue: $setup.memberForm.message,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.memberForm.message) = $event)),
                    variant: "outlined"
                  }, null, 8, ["modelValue"]),
                  ($setup.errorMessage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($setup.errorMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_v_btn, {
                    class: "button button-orange",
                    onClick: $setup.onClickSendInvitation
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Send Invitation")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["rules"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}